/**
 * @desc 分页
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.inPlanMaster.listPage.Params, options?: any) {
  return updateResponse(
    http(URL + `/inPlanMaster/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
